import { render } from "./NcPopover.vue?vue&type=template&id=6432395a&scoped=true"
import script from "./NcPopover.vue?vue&type=script&lang=js"
export * from "./NcPopover.vue?vue&type=script&lang=js"

import "./NcPopover.vue?vue&type=style&index=0&id=6432395a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6432395a"]])

export default __exports__